import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import UnitboxContainer from '../unitboxContainer';
import TextboxContainer from '../textboxContainer';
import CheckboxContainer from '../checkboxContainer';
import DropdownContainer from '../dropdownContainer';
import RangeboxContainer from '../rangeboxContainer';
import CheckboxAutosuggetContainer from '../checkboxAutosuggetContainer';
import TextboxAutosuggestContainer from '../textboxAutosuggestContainer';
import FixedboxContainer from '../fixedboxContainer';
import { updateSpecificationData } from '../../../../../actions/productSpecification';
import DateContainer from '../dateContainer';

function FormContainer(props) {
    const [puvAttributes, setPuvAttributes] = useState([]);

    useEffect(() => {
        if(props.savedPuvSpecAttributes.length){
            setPuvAttributes(JSON.parse(JSON.stringify(props.savedPuvSpecAttributes)));
        }else{
            setPuvAttributes(JSON.parse(JSON.stringify(props.editablePuvSpecAttributes)));
        }
    }, [props.savedPuvSpecAttributes, props.editablePuvSpecAttributes]);

    return puvAttributes.length && puvAttributes.map((element, index) => {
        const { s_type, s_subType='', s_dnm='' , s_nm='' } = element;
        const componentOptions = {
            key : `${s_type}-${index}`,
            parentIndex: index,
            isEnrichSpec: props?.isEnrichSpec
        }
        if(['brand', 'manufacturer', 'manufactured_details','importer','importers_detail','country_of_origin','packaging_width','packaging_height','packaging_length','packaging_weight', 'price','expiry_date'].includes(s_nm.toLowerCase())){
            console.log(s_dnm)
            return null;
        }
        switch(s_type.toLowerCase()){
            case "textbox":
            case "textarea":
                if(s_subType && s_subType.includes("Unitbox")){
                    return <UnitboxContainer {...componentOptions} showSellOnline={props.showSellOnline} err={element.userInput.error} />
                }
                return <TextboxContainer {...componentOptions} showSellOnline={props.showSellOnline} err={element.userInput.error} />
            case "checkbox":
                return <CheckboxContainer {...componentOptions} showSellOnline={props.showSellOnline} err={element.userInput.error} />
            case "checkboxautosuggest":
                return <CheckboxAutosuggetContainer {...componentOptions} showSellOnline={props.showSellOnline} err={element.userInput.error} />
            
            case "dropdown":
            case "dropdownautosuggest":
                return <DropdownContainer {...componentOptions} showSellOnline={props.showSellOnline} err={element.userInput.error} isAutoSuggest={s_type.toLowerCase() == 'dropdownautosuggest'}/>
            case "textboxautosuggest":
                return <TextboxAutosuggestContainer {...componentOptions} showSellOnline={props.showSellOnline} err={element.userInput.error} />
            case "rangebox":
                return <RangeboxContainer {...componentOptions} showSellOnline={props.showSellOnline} err={element.userInput.error} />
            case "fixed":
                return <FixedboxContainer {...componentOptions} showSellOnline={props.showSellOnline} err={element.userInput.error} />
            case "date":
                return <DateContainer {...componentOptions} showSellOnline={props.showSellOnline} err={element.userInput.error} />
        }
    }) || '';
}

const mapStateToProps = (state) => {
    return {
        savedPuvSpecAttributes: state.productSpecification.savedPuvSpecAttributes,
        editablePuvSpecAttributes: state.productSpecification.editablePuvSpecAttributes,
        categoryType: state.products.selectedCategoryType
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSpecificationData: (payload) => dispatch(updateSpecificationData(payload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);
